<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="kycStatus === 2 ? $t('kyc.verifying_title') : $t('kyc.verify_popup_title')"
    width="720px"
    :close-on-click-modal="false"
    :show-close="true"
    class="verify-popup-dialog"
    @close="onClose"
  >
    <!-- Verifying state: show simple "in progress" content -->
    <div v-if="kycStatus === 2" class="verify-body">
      <div class="verify-avatar">
        <svg-icon icon-class="user" class-name="verify-avatar-icon" />
      </div>
      <div class="verify-content">
        <div class="verify-main">{{ $t('kyc.verifying_main') }}</div>
        <div class="verify-sub">{{ $t('kyc.verifying_sub') }}</div>
      </div>
    </div>

    <!-- Unverified / Rejected: original verify-now content -->
    <div v-else class="verify-body">
      <div class="verify-avatar">
        <svg-icon icon-class="user" class-name="verify-avatar-icon" />
      </div>
      <div class="verify-content">
        <div class="verify-main">{{ $t('kyc.verify_main') }}</div>
        <div class="verify-sub">{{ $t('kyc.verify_sub') }}</div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer" style="display:flex;justify-content:flex-end;">
      <el-button v-if="kycStatus !== 2" class="verify-cancel" @click="goToDashboard">{{ $t('kyc.cancel') }}</el-button>
      <el-button v-if="kycStatus !== 2" type="primary" class="verify-now" @click="onVerify">{{ $t('kyc.verify_now') }}</el-button>
      <el-button v-else type="primary" class="verify-now" @click="goToDashboard">{{ $t('kyc.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'VerifyNowPopup',
  computed: {
    dialogVisible: {
      get() {
        return this.$store.getters.showPendingPopup
      },
      set(val) {
        this.$store.commit('app/SET_PENDING_POPUP', !!val)
      }
    },
    kycStatus() {
      const merchantInfo = this.$store.getters.userInfo && this.$store.getters.userInfo.merchant_info
      return merchantInfo && merchantInfo.kyc_status ? merchantInfo.kyc_status : null
    }
  },
  methods: {
    onVerify() {
      this.gotoKyc = true
      this.$store.commit('app/SET_PENDING_POPUP', false)
    },
    onClose() {
      if (this.gotoKyc) this.$router.push('/kyc')
      else this.$router.push('/dashboard')
      this.gotoKyc = false
    },
    goToDashboard() {
      this.gotoKyc = false
      this.$store.commit('app/SET_PENDING_POPUP', false)
    }
  }
}
</script>

<style scoped>
.verify-body {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 28px 16px;
  text-align: center;
  word-break: keep-all;
}
.verify-avatar {
  margin-bottom: 12px;
}
.verify-avatar-icon {
  width: 48px;
  height: 48px;
  color: #6b7280;
}
.verify-main {
  font-size: 18px;
  color: #13355a;
  font-weight: 600;
  margin-bottom: 8px;
}
.verify-sub {
  font-size: 14px;
  color: #3b5b86;
}
.verify-now {
  border-radius: 8px;
  padding: 10px 20px;
  margin-left: 12px;
}
.verify-cancel {
  border-radius: 8px;
  padding: 10px 20px;
}
</style>

